// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
export default `
uniform sampler2D uMask;
uniform sampler2D uShadow;
uniform sampler2D uShadowGlow;
uniform vec3 uColor;
uniform vec3 uColor2;
uniform float uTime;
uniform vec3 uRandom;
uniform vec3 uBgColor;

varying vec2 vUv;
varying float vAlpha;

void main(){
  float alpha = smoothstep(0.3, 1.0, texture2D(uMask, vUv).r);
  float glow = texture2D(uShadowGlow, vUv).r;
  alpha += glow;

  float shadow = texture2D(uShadow, vUv).r;

  float noise = snoise(vec3(vUv * 2.0, uTime * 0.4 + uRandom.x)) * 0.5 + 0.5;

  vec3 brightColor = mix(uColor2, vec3(1.0), noise * 0.3);
  vec3 color = mix(uColor, brightColor, (1.0 - shadow) * noise);

  color = mix(color, color + 0.1, sin(uTime * 0.2 + uRandom.y) * 0.5 + 0.5);

  color = mix(uBgColor, color, vAlpha);



  gl_FragColor = vec4(color, alpha);
}
`
